import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store/index';
import ElementUI from "element-ui";
import Video from "video.js"
import Cookies from 'js-cookie'
import install from './directives';
import "video.js/dist/video-js.css"
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/style.less'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(install);

Vue.prototype.$video = Video

function getRandomUserId() {
  // 尝试从cookie中读取用户ID
  let userId = Cookies.get('randomUserId');
  
  // 如果没有找到用户ID，生成一个新的随机ID并存入cookie
  if (!userId) {
    userId = 'user_' + Math.random().toString(36).substr(2, 9);
    Cookies.set('randomUserId', userId, { expires: 7 }); // 设置过期时间，比如7天
  }

  return userId;
}

const randomUserId = getRandomUserId();

// Mock.bootstrap()

new Vue({
  data(){
    return {
      userId: randomUserId
    }
  },
  render: function (h) { return h(App) },
  store,
  router,
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  beforeMount() {
    Vue.prototype.$bus = this //全局事件总线
  }
}).$mount('#app')
